import { render, staticRenderFns } from "./DrawModal.vue?vue&type=template&id=28920ebe&scoped=true&"
import script from "./DrawModal.vue?vue&type=script&lang=js&"
export * from "./DrawModal.vue?vue&type=script&lang=js&"
import style0 from "./DrawModal.vue?vue&type=style&index=0&id=28920ebe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28920ebe",
  null
  
)

export default component.exports